<svg
  [attr.width]="width"
  [attr.height]="height"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class="block"
>
  <g clip-path="url(#clip_inbox)">
    <path
      d="M2.08332 10H4.90163C5.47263 10 5.99463 10.3226 6.24999 10.8333C6.50535 11.3441 7.02735 11.6667 7.59835 11.6667H12.4016C12.9726 11.6667 13.4946 11.3441 13.75 10.8333C14.0054 10.3226 14.5273 10 15.0984 10H17.9167M7.47213 3.33333H12.5279C13.4252 3.33333 13.8739 3.33333 14.2701 3.46997C14.6204 3.5908 14.9395 3.788 15.2042 4.04729C15.5036 4.3405 15.7042 4.74183 16.1056 5.54448L17.911 9.15542C18.0685 9.47041 18.1473 9.6279 18.2028 9.79296C18.2521 9.93954 18.2877 10.0904 18.3092 10.2436C18.3333 10.416 18.3333 10.5921 18.3333 10.9443V12.6667C18.3333 14.0668 18.3333 14.7669 18.0608 15.3016C17.8212 15.772 17.4387 16.1545 16.9683 16.3942C16.4335 16.6667 15.7335 16.6667 14.3333 16.6667H5.66666C4.26653 16.6667 3.56646 16.6667 3.03168 16.3942C2.56128 16.1545 2.17882 15.772 1.93914 15.3016C1.66666 14.7669 1.66666 14.0668 1.66666 12.6667V10.9443C1.66666 10.5921 1.66666 10.416 1.6908 10.2436C1.71224 10.0904 1.74785 9.93954 1.79717 9.79296C1.85271 9.6279 1.93146 9.4704 2.08895 9.15542L3.89442 5.54448C4.29574 4.74183 4.49641 4.3405 4.79578 4.04729C5.06052 3.788 5.37959 3.5908 5.7299 3.46997C6.12603 3.33333 6.57473 3.33333 7.47213 3.33333Z"
      stroke="var(--stroke-color)"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </g>
  <defs>
    <clipPath id="clip_inbox">
      <rect width="20" height="20" fill="white" />
    </clipPath>
  </defs>
</svg>
